import axios from '@/_services/axios';

export function GetAllPaging(take, skip) {
  return new Promise((resolve, reject) => {
    axios
      .get(`materials/all?take=${take}&skip=${skip}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetAll() {
  return new Promise((resolve, reject) => {
    axios
      .get('materials/all')
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function Get(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`materials/${id}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetSearch(text, take, skip) {
  return new Promise((resolve, reject) => {
    axios
      .get(`materials/search?take=${take}&skip=${skip}&searchParam=${text}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function Save(material, isUserAdmin) {
  if (material.id === 0) {
    return Create(material);
  }
  return isUserAdmin ? EditAsAdmin(material) : EditAsUser(material);
}

export function Create(item) {
  return new Promise((resolve, reject) => {
    axios
      .post('materials', {
        laborConstant: item.laborConstant,
        name: item.name,
        unitId: item.unit,
        unitPrice: item.unitPrice,
        laborId: item.labor,
      })
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function EditAsAdmin(item) {
  return new Promise((resolve, reject) => {
    axios
      .put(`materials/${item.id}`, {
        laborConstant: item.laborConstant,
        name: item.name,
        unitId: item.unit,
        unitPrice: item.unitPrice,
        laborId: item.labor,
      })
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function EditAsUser(item) {
  return new Promise((resolve, reject) => {
    axios
      .put(`materials/${item.id}/price`, { cost: item.userPrice })
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function UpdateMaterial(compositeMaterialId, quantity) {
  return new Promise((resolve, reject) => {
    axios
      .put(`materials/${compositeMaterialId}/quantity`, { quantity })
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  });
}

export function UpdateSubcontractingCost(compositeMaterialId, quantity) {
  return new Promise((resolve, reject) => {
    axios
      .put(`materials/${compositeMaterialId}/subcontracting`, { quantity })
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  });
}

export function UpdateLaborConstant(compositeMaterialId, quantity) {
  return new Promise((resolve, reject) => {
    axios
      .put(`materialComposites/${compositeMaterialId}/laborConstant`, {
        quantity,
      })
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  });
}

export function UpdateLaborHourlyRate(compositeMaterialId, quantity) {
  return new Promise((resolve, reject) => {
    axios
      .put(`materials/${compositeMaterialId}/laborHourlyRate`, {
        quantity,
      })
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  });
}

export function UpdateEstimatedLabourTime(compositeMaterialId, quantity) {
  return new Promise((resolve, reject) => {
    axios
      .put(`/materials/${compositeMaterialId}/estimatedLaborTime`, {
        quantity: quantity,
      })
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  });
}

export function DeleteMaterial(id) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`materials/${id}`, { responseType: 'text' })
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function DeleteUserMaterial(id) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`materials/${id}/user`, { responseType: 'text' })
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function RemoveMaterial(materialId) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`materialComposites/${materialId}`, { responseType: 'text' })
      .then(resp => resolve(resp))
      .catch(err => reject(err));
  });
}
